import { FieldType, MailingListPublicationInfoField } from '../../../components/GenericSection/constants';
import { DATE_ACCESSED, ELEC_PUB_DATE, MAILING_PUBLISHER, MAILING_TITLE, NEWSGROUP_TITLE, URL } from '../../constants';

/** field list for publication mailing list info section */
export var getPubMailingListInfoSectionFieldList = function getPubMailingListInfoSectionFieldList() {
  var isNewsGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return [{
    field: MailingListPublicationInfoField.TITLE,
    labelText: isNewsGroup ? NEWSGROUP_TITLE : MAILING_TITLE,
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: MailingListPublicationInfoField.PUBLISHER,
    labelText: MAILING_PUBLISHER,
    type: FieldType.TEXT
  }, {
    field: MailingListPublicationInfoField.URL,
    labelText: URL,
    recommended: true,
    type: FieldType.TEXT
  }, {
    field: MailingListPublicationInfoField.ELEC_PUB_DATE,
    type: FieldType.PUBDATE,
    labelText: ELEC_PUB_DATE,
    formikFieldNames: ['day', 'month', 'year']
  }, {
    field: MailingListPublicationInfoField.DATE_ACCESSED,
    type: FieldType.PUBDATE,
    labelText: DATE_ACCESSED,
    formikFieldNames: ['dayaccessed', 'monthaccessed', 'yearaccessed']
  }];
};